module.exports = __webpack_public_path__ + "static/media/p2_s3b.7af42a78.ogg";